export function Spinner() {
  return <span className="cg-spinner" role="status" aria-label="loading" />;
}
